<template>
  <div class="c-overlay-manager">
    <overlay v-for="overlay in overlays" :key="overlay.id" :overlay="overlay"></overlay>
  </div>
</template>

<script>
  // Vuex
  import { mapActions, mapGetters } from 'vuex';
  
  // Components
  import Overlay from '@/plugins/overlay/Overlay.vue';
  
  export default {
    name: 'OverlayManager',
    
    components: {
      Overlay
    },

    computed: {
      ...mapGetters([
        'overlays'
      ])
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/plugins/overlay/OverlayManager.vue